import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';
import { EMPTY_ARRAY } from 'constants/defaults';
import type { Client, ClientDraft } from 'types/client';
import type { ClientsState, FilterState, FilterType } from './clients.types';
import { calculateProjectCounts } from './clients.utils';

const initialFilterState: FilterState = {
  query: '',
  filter: 'active',
};

const initialState: ClientsState = {
  draft: null,
  entries: EMPTY_ARRAY,
  filter: initialFilterState,
  projectsCount: 0,
};

const clientsSlice = createSlice({
  name: 'clients',
  initialState,
  reducers: {
    searchClients: (state, action: PayloadAction<string>) => {
      state.filter.query = action.payload;
    },
    filterClients: (state, action: PayloadAction<FilterType>) => {
      state.filter.filter = action.payload;
    },
    resetClients: state => {
      state.filter = initialFilterState;
    },
    fetchedClients: (state, action: PayloadAction<Array<Client>>) => {
      state.entries = action.payload;
      state.projectsCount = calculateProjectCounts(state.entries).active;
    },
    savedClient: (state, action: PayloadAction<{ client: Client; createdEntry?: boolean }>) => {
      const { client, createdEntry } = action.payload;
      if (createdEntry) {
        state.entries.push(client);
      } else {
        const index = state.entries.findIndex(c => c.id === client.id);
        if (index !== -1) {
          state.entries[index] = client;
        }
      }
      state.projectsCount = calculateProjectCounts(state.entries).active;
    },
    fetchedClient: (state, action: PayloadAction<{ client: Client }>) => {
      const { client } = action.payload;
      const index = state.entries.findIndex(c => c.id === client.id);
      if (index !== -1) {
        state.entries[index] = client;
      } else {
        state.entries.push(client);
      }
      state.projectsCount = calculateProjectCounts(state.entries).active;
    },
    initiateClientDraft: (state, action: PayloadAction<ClientDraft>) => {
      state.draft = action.payload;
    },
    updateClientDraft: (state, action: PayloadAction<ClientDraft>) => {
      state.draft = action.payload;
    },
    clearClientDraft: state => {
      state.draft = null;
    },
  },
});

export const { actions } = clientsSlice;

export default clientsSlice.reducer;
